import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiMenuItem } from 'ui-components';

export const StyledCustomerLabelFilter = styled('div')(
  ({ theme }) => css`
    width: 280px;

    .placeholder {
      color: ${theme.palette.secondary.moreLight};
    }
  `
);

export const StyledMenuItem = styled(UiMenuItem)(
  () => css`
    &.MuiMenuItem-root {
      margin-top: 4px;
      margin-bottom: 4px;
    }

    &.MuiMenuItem-root.Mui-selected .icon {
      filter: brightness(0) invert(1);
    }
  `
);
